var openLink = function (link, newTab) {
  if (newTab === void 0) {
    newTab = false;
  }
  if (newTab) {
    window.open(link);
    return;
  }
  window.location.href = link;
  return;
};

export { openLink };
